export default __webpack_public_path__ + "static/media/May2019.55ca056e.png";